import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import CloseIcon from 'resources/X_close_icon.png';
import './WStoreAlertNew.css';

const WStoreAlertNew = ({ alertMsg, onClose }) => {
  return (
    <Modal
      className="modal-dialog-wstore-alert-new"
      show={!!alertMsg}
      onHide={onClose}
    >
      <Modal.Body>
        <button className="exit-modal-button" type="button" onClick={onClose}>
          <img src={CloseIcon} alt="Close purchase modal" />
        </button>
        <img src={alertMsg.icon} alt="WStore Icon" className="wstore-icon" />
        <div className="title">{alertMsg.title}</div>
        <div className="body-text">{alertMsg.body}</div>
        <button type="button" className="close-button " onClick={onClose}>
          Close
        </button>
      </Modal.Body>
    </Modal>
  );
};

WStoreAlertNew.propTypes = {
  alertMsg: PropTypes.shape({
    body: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string
  }),
  onClose: PropTypes.func
};

export default WStoreAlertNew;
